import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { useState } from "react";

import { createQueryClient } from "@/lib/api/queries";
import { AuthProvider } from "@/lib/auth/auth-provider";

import { makeRouter } from "./router";
import { ToastProvider } from "./toast";

/** Query client, toasts, auth (local stub or Clerk, on the flag) and the router. */
export function App() {
  const [queryClient] = useState(createQueryClient);
  const [router] = useState(() => makeRouter(queryClient));
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AuthProvider history={router.history}>
          <RouterProvider router={router} />
        </AuthProvider>
      </ToastProvider>
    </QueryClientProvider>
  );
}
